import { useFlag } from '@unleash/proxy-client-react';

import { getEnv } from './useEnv';

const allFlags = {
  // BETA:
  showNpsModule: true,
  showCampaigns: false,
  // DELTA
  contactMenuBarImport: true,
  showBlockModalFreeTrialDemo: true,
  SkipButtonStepper: false,
  createContactsV2: false,
  distributeSegment: true,
  recentImportIsEnabled: true,
  // Features no implemented
  channelDateFilter: true,
  actionBarDropdown: true,
  actionBarGroupsFlowsIcon: false,
  actionBarExportUserIcon: true,
  actionBarMergeTagIcon: true,
  actionBarEditTagCategoryIcon: true,
  // Heavy operations that could be useful keep the control with the FF
  actionBarTagAddIcon: true,
  actionBarGroupAddIcon: true,
  actionBarFlowsIcon: false,
  // 4 DEVELOPERS
  showCrashButton: true,
  loginAuditStep: true,
  loginV2CheckCountry: true,
  MFA: true
};

type AppFlagKeys = keyof typeof allFlags;

export const useFeatureFlag = (flag: AppFlagKeys) => {
  const env = getEnv();
  const isFlagEnabled = useFlag(flag);
  if (env === 'development' || env === 'storybook') {
    return allFlags[flag];
  }
  return isFlagEnabled;
};
